<script setup lang="ts">
  import { computed } from 'vue'
  import AppChart from '@/components/app-chart.vue'

  const props = defineProps<{
    title: string,
    data: OrderStats[],
  }>()

  const chartData = computed(() => {
    return {
      completed: props.data.map((d) => d.completed),
      canceled: props.data.map((d) => d.canceled),
    }
  })

  const chartCategories = computed(() => {
    return props.data.map((d) => d.group)
  })

  const chartOptions = computed(() => {
    return {
      accessibility: { enabled: true },
      chart: {
        type: 'column',
        style: {
          fontFamily: 'inherit',
        },
      },
      title: {
        text: props.title,
        style: {
          fontSize: '18px',
          fontWeight: '600',
        },
      },
      yAxis: {
        title: { text: '' },
        gridLineColor: '#f0f0f0',
      },
      xAxis: {
        categories: chartCategories.value,
        lineColor: '#e0e0e0',
        tickColor: '#e0e0e0',
      },
      plotOptions: {
        column: {
          borderRadius: 4,
        },
      },
      colors: ['#10B981', '#EF4444'],
      series: [
        { name: 'Selesai', data: chartData.value.completed },
        { name: 'Dibatalkan', data: chartData.value.canceled },
      ],
      credits: { enabled: false },
    } as Highcharts.Options
  })
</script>

<template>
  <app-chart
    constructor-type="chart"
    :options="chartOptions" />
</template>
